import * as React from 'react'

import { Callout as CalloutComponent } from '@ulule/owl-kit-components/next'

import { useMessage } from '../useMessage'

type CalloutProps = {
  children?: React.ReactNode
  contexts?: string[]
}

export function Callout({ children, contexts = [] }: CalloutProps): React.ReactElement<CalloutProps> {
  const { messages } = useMessage(contexts)

  return (
    <>
      {messages.map((message) => {
        const { context, extra, level, message: content } = message
        return (
          <>
            <CalloutComponent key={context} type={level}>
              {content}
            </CalloutComponent>
            {React.Children.map(children, (child) => {
              if (React.isValidElement(child)) {
                // TODO: FIXME: Add `key`
                return React.cloneElement(child, { ...extra })
              }
            })}
          </>
        )
      })}
    </>
  )
}
